import React, { useState, useEffect } from 'react';

import { TablePagination } from '@material-ui/core';
import styled from 'styled-components';
import { StyledTypography } from 'styles/common';

import NoReviewsImage from 'assets/images/noReviewsImage.jpg';

import QuestionRow from './questionRow';
import QuestionsListHeader from './questionsListHeader';
import QuestionsLoader from './questionsLoader';
import SearchQuestions from './searchQuestions';

const QuestionsList = ({
  source,
  questions,
  loading,
  menuOptions,
  updateData,
  competencies,
  drivers,
  noDataMessage = '',
  noDataSubMessage = '',
  rowClickable = true,
}) => {
  const [search, setSearch] = useState({
    text: '',
    answerType: '',
    questionType: '',
    driver: '',
  });
  const [count, setCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [filteredQuestions, setFilteredQuestions] = useState([]);
  const limit = 10;

  useEffect(() => {
    if (questions && questions.length > 0) {
      filterData(search, questions, currentPage);
    }
  }, [questions]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
    filterData(search, questions, page);
  };

  const filterData = (searchData, data, page) => {
    let result = [...data];
    if (searchData.text) {
      result = result.filter((d) => d.description?.toLowerCase().indexOf(searchData.text?.toLowerCase()) > -1);
    }
    if (searchData.answerType && searchData.answerType !== 'ALL') {
      result = result.filter((d) => d.answerType.indexOf(searchData.answerType) > -1);
    }
    if (searchData.questionType && searchData.questionType !== 'ALL') {
      result = result.filter((d) => d.questionType && d.questionType.indexOf(searchData.questionType) > -1);
    }
    if (searchData.driver && searchData.driver !== 'ALL') {
      result = result.filter((d) => d.tagId && d.tagId.indexOf(searchData.driver) > -1);
    }
    setCount(result.length);
    setFilteredQuestions(result.filter((r, i) => i >= page * limit && i < (page + 1) * limit));
  };

  const onSearchChange = (param, e) => {
    setCurrentPage(0);
    const searchData = { ...search, [param]: e.target.value };
    setSearch(searchData);
    filterData(searchData, questions, 0);
  };

  return (
    <>
      <>
        <SearchQuestions source={source} search={search} onSearchChange={onSearchChange} drivers={drivers} />
        <Separator />
        <QuestionsListHeader source={source} />
        <Separator />
      </>
      {questions.length || loading ? (
        <BodyContainer>
          {loading ? (
            <QuestionsLoader />
          ) : (
            <>
              {filteredQuestions.map((question) => (
                <QuestionRow
                  source={source}
                  question={question}
                  rowClickable={rowClickable}
                  menuOptions={menuOptions}
                  updateData={updateData}
                  competencies={competencies}
                  drivers={drivers}
                />
              ))}
              <StyledTablePagination
                component="div"
                count={count}
                rowsPerPage={limit}
                rowsPerPageOptions={[]}
                page={currentPage}
                onChangePage={(e, newPage) => handlePageChange(newPage)}
                labelRowsPerPage={null}
              />
            </>
          )}
        </BodyContainer>
      ) : (
        <NoResultsContainer>
          <img src={NoReviewsImage} alt="No questions were found" />
          {noDataMessage && <StyledTypography color="#000">{noDataMessage}</StyledTypography>}
          {noDataSubMessage && <StyledTypography color="#999">{noDataSubMessage}</StyledTypography>}
        </NoResultsContainer>
      )}
    </>
  );
};

const Separator = styled.hr`
  border: 0;
  height: 0;
  border-top: 1px solid #eaeaea;
`;

const BodyContainer = styled.div`
  margin-top: -6px;
`;

const NoResultsContainer = styled.div`
  text-align: center;
  padding: 4rem;
  img {
    width: 27.5%;
    margin-bottom: 1.5rem;
  }
  .MuiTypography-root {
    font-size: 1.25rem;
  }
`;

const StyledTablePagination = styled(TablePagination)`
  margin: 0.5rem 1rem;
`;

export default QuestionsList;
